import { lazy } from 'react';
export var BaseEditPageAsync = lazy(function () { return import('./BaseEditPage'); });
